import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { ArrowLeft, FileSpreadsheet, Smartphone, Mail } from 'lucide-react';
import BulkImportTab from '../../components/admin/BulkImportTab';
import PhoneSyncTab from '../../components/admin/PhoneSyncTab';
import EmailSyncTab from '../../components/admin/EmailSyncTab';

const DataImportPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-primary text-white px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <Button 
            variant="ghost" 
            size="icon"
            onClick={() => navigate('/admin/system')}
            className="text-white hover:bg-white/20"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="font-serif text-xl font-semibold">Data Import Tools</h1>
            <p className="text-xs text-white/70">Bulk import and sync tenant data</p>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto p-6">
        <Tabs defaultValue="bulk" className="space-y-6">
          <TabsList>
            <TabsTrigger value="bulk">
              <FileSpreadsheet className="w-4 h-4 mr-2" /> Bulk Import
            </TabsTrigger>
            <TabsTrigger value="phone">
              <Smartphone className="w-4 h-4 mr-2" /> Phone Sync
            </TabsTrigger>
            <TabsTrigger value="email">
              <Mail className="w-4 h-4 mr-2" /> Email Sync
            </TabsTrigger>
          </TabsList>

          {/* Bulk Import Tab */}
          <TabsContent value="bulk">
            <BulkImportTab />
          </TabsContent>

          {/* Phone Sync Tab */}
          <TabsContent value="phone">
            <PhoneSyncTab />
          </TabsContent>

          {/* Email Sync Tab */}
          <TabsContent value="email">
            <EmailSyncTab />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default DataImportPage;
